export default function() {
  return new Worker(__webpack_public_path__ + "static/js/notify.worker.b973d492.worker.js");
}
